import { useColorMode } from "@chakra-ui/react";
import AsyncSelect from 'react-select/async';

export default function Select2({required = false, defaultValue = null, value, isClearable, onChange = () => {}, loadOptions, placeholder, ...props }) {
  const {colorMode} = useColorMode()
  const isDark = colorMode === 'dark';
  const darkStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#3F444E',   // fundo do input
      borderColor: state.isFocused ? '#555' : '#444',
      boxShadow: 'none',
      ':hover': {
        borderColor: '#666',
      },
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: '#3F444E',   // fundo do dropdown
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? '#3F444E'                    // selecionado
        : state.isFocused
        ? '#3F444E'                 // hover
        : '#636975',
      color: '#fff',
      ':active': {
        backgroundColor: '#3F444E',
      },
    }),

    singleValue: (base) => ({
      ...base,
      color: '#fff',
    }),

    input: (base) => ({
      ...base,
      color: '#fff',
    }),

    placeholder: (base) => ({
      ...base,
      color: '#aaa',
    }),
  };


  return (
    <AsyncSelect
      styles={isDark ? darkStyles : undefined}
      required={required}
      cacheOptions
      defaultValue={defaultValue}
      value={value}
      isClearable={isClearable}
      onChange={onChange}
      loadOptions={loadOptions}
      placeholder={placeholder}
      {...props}
    />
  )
}
